import { render, staticRenderFns } from "./documentation-list-item.component.vue?vue&type=template&id=4b281064"
import script from "./documentation-list-item.component.ts?vue&type=script&lang=ts&external"
export * from "./documentation-list-item.component.ts?vue&type=script&lang=ts&external"
import style0 from "./documentation-list-item.component.vue?vue&type=style&index=0&id=4b281064&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4b281064')) {
      api.createRecord('4b281064', component.options)
    } else {
      api.reload('4b281064', component.options)
    }
    module.hot.accept("./documentation-list-item.component.vue?vue&type=template&id=4b281064", function () {
      api.rerender('4b281064', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/documentation-list-item/documentation-list-item.component.vue"
export default component.exports